<template>
  <div style="display: flex;align-content: center;padding-left: 5px;">
    <span :style="styleCurrency">{{ total.currency }}</span>
    <span :style="style">{{ total.amount }}</span>
  </div>
</template>

<script>

export default {
  name: 'ChangeChargeCountItemRenderer',
  props: {
    item: {
      type: Object, required: true
    }
  },
  computed: {
    styleCurrency() {
      const { item } = this
      return { 'font-weight': 'bold', 'font-size': '13px', color: item.diff ? '#ff0000' : '#000000' }
    },
    style() {
      const initStyle = this.item.style || { 'text-decoration': this.item.textDecoration ? 'underline' : 'none' }
      const { item } = this
      return { 'font-style': 'oblique', 'text-decoration': 'none', ...initStyle, 'font-size': '12px', color: item.diff ? '#ff0000' : '#000000' }
    },
    total() {
      const { item } = this
      const currency = item.currency + ':'
      const result = { ...item, currency, amount: this.$numeral(item.amount).format('0.00') }
      return result
    }
  }
}
</script>
